import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { chatFetch, extractErrorMessage } from '../../Services/authClient';

const ChatPage = () => {
  const { t } = useTranslation();
  const [conversations, setConversations] = useState([]);
  const [status, setStatus] = useState('loading');
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    setStatus('loading');
    chatFetch('/chat-api/conversations/?ordering=-updated_at')
      .then((data) => {
        const list = Array.isArray(data) ? data : data?.results || [];
        setConversations(list);
        setStatus(list.length === 0 ? 'empty' : 'ready');
      })
      .catch((error) => {
        setStatus(extractErrorMessage(error, t('app.chat.loadError', 'Unable to load conversations.')));
      });
  }, [t]);

  const filteredConversations = useMemo(() => {
    if (!searchTerm) return conversations;
    return conversations.filter((conversation) => {
      const haystack = `${conversation.title || ''} ${conversation.fanzone || ''} ${conversation.last_message || ''}`.toLowerCase();
      return haystack.includes(searchTerm.toLowerCase());
    });
  }, [conversations, searchTerm]);

  const renderStatus = () => {
    if (status === 'loading') {
      return <p className="chat__status">{t('app.chat.loading', 'Loading conversations…')}</p>;
    }
    if (status === 'empty') {
      return <p className="chat__status">{t('app.chat.empty', 'No conversations yet. Tap a rivalry to get started.')}</p>;
    }
    if (typeof status === 'string' && status !== 'ready') {
      return <p className="chat__status is-error">{status}</p>;
    }
    return null;
  };

  return (
    <div className="chat">
      <div className="chat__toolbar">
        <input
          type="search"
          placeholder={t('app.chat.search', 'Search rivals, crews…')}
          value={searchTerm}
          onChange={(event) => setSearchTerm(event.target.value)}
        />
      </div>

      {renderStatus()}

      <div className="chat__list">
        {filteredConversations.map((conversation) => (
          <article key={conversation.id} className="chat-card">
            <div className="chat-card__avatar">
              <span>{(conversation.title || conversation.fanzone || '?').slice(0, 2).toUpperCase()}</span>
            </div>
            <div className="chat-card__body">
              <div className="chat-card__title">
                <strong>{conversation.title || conversation.fanzone || t('app.chat.untitled', 'Supporter chat')}</strong>
                <small>{new Date(conversation.updated_at || Date.now()).toLocaleString()}</small>
              </div>
              <p className="chat-card__snippet">{conversation.last_message || t('app.chat.snippetFallback', 'Tap to continue the conversation.')}</p>
              <div className="chat-card__meta">
                <span>{conversation.member_count || 0} {t('app.chat.members', 'members')}</span>
                <span>{conversation.category || ''}</span>
              </div>
            </div>
            <button type="button" className="chat-card__cta">
              {t('app.chat.open', 'Tap')}
            </button>
          </article>
        ))}
      </div>
    </div>
  );
};

export default ChatPage;
